import { DashboardTile } from "../components/DashboardTile";
import { TileHeader } from "../components/TileHeader";

export const PointsPromoTile = () => {
  return (
    <DashboardTile className="flex flex-col justify-between">
      <TileHeader>POINTS</TileHeader>
      <div className="flex h-full w-full flex-col items-center justify-center">
        <div>
          <div className="text-center font-serif text-5xl">2X</div>
          <div className="text-center text-sm text-slate">
            on every day spend
          </div>
        </div>
        <div className="pt-10">
          <div className="text-center font-serif text-5xl">3X</div>
          <div className="text-center text-sm text-slate">
            on company expenses
          </div>
        </div>
      </div>
    </DashboardTile>
  );
};
